export const EDIT_USER_PROFILE_TABS = {
  PROFILE: 'profile',
  ACCESS: 'access',
  CREDENTIALS: 'credentials',
  BILLING: 'billing',
};

// eslint-disable-next-line import/prefer-default-export
export const FCM_TOKEN_MAX_COUNT = 50; // Product limit (agreed with PM)

/** The fields bulk edit can change, in the order the Bulk edit menu lists them. */
export const BULK_EDIT_ACTIONS = {
  CREDENTIALS: 'credentials',
  UNIT: 'unit',
  ROLE: 'role',
  STATUS: 'status',
};

export const USER_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
};
